import api from '../../api';
import { Candidato } from '../../model/Candidato/Candidato';

export class EnviarEmailHeteroidentificacao {
    static async enviarEmails(processoId: string, candidatos: Candidato[]): Promise<boolean> {
        try {
            const ids = candidatos.map((candidato) => candidato.id);
            const response = await api.post(`/emails/convocacao/candidatos?processoId=${processoId}`, ids);

            return response.status >= 200 && response.status < 300;
        } catch (error) {
            console.error('Erro ao enviar emails:', error);
            throw error;
        }
    }

    static async enviarEmailResultadoCandidato(params: {
        bancaId: string;
        candidatosIds?: string[] | null;
        apenasContagem?: boolean;
    }): Promise<{ emailsEnviadosValidado: number; emailsEnviadosNaoValidado: number; emailsEnviadosInconclusivo: number; totalElegivel?: number }> {
        const { bancaId, candidatosIds, apenasContagem } = params;

        const response = await api.post(`/emails/bancas/${bancaId}/candidatos/enviaResultados?apenasContagem=${apenasContagem || false}`, {
            candidatosIds: candidatosIds || null,
        });

        return response.data;
    }

    static async enviarTermoIndividual(bancaId: string, candidatoId: string): Promise<void> {
        await api.post(`/emails/bancas/${bancaId}/candidatos/enviaResultados`, {
            candidatosIds: [candidatoId],
        });
    }
}
